module.exports = __webpack_public_path__ + "static/media/error.0e39398.wav";